import React, {Component, Fragment} from 'react';
import { ResponsiveLine } from '@nivo/line'


class OitStatistics extends Component {
  render() {
    console.log('firstQuestion', this.props.firstQuestion)
    return <div style={{height: '600px'}}><ResponsiveLine
      data={this.props.data}
      curve="monotoneX"
      margin={{ top: 100, right: 70, bottom: 200, left: this.props.firstQuestion && this.props.firstQuestion.overrideDefaultScores? 100:30 }}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 0,
        max: 7,
        step: 1,
        clamp: false,
        stacked: false,
        reverse: false,
      }}
      yFormat=" >-.2f"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: 'top',
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: 36,
        legendPosition: 'middle',
        renderTick: ({
                       opacity,
                       textAnchor,
                       textBaseline,
                       textX,
                       textY,
                       theme,
                       value,
                       x,
                       y
                     }) => {
          return (
            <g
              transform={`translate(${x},0)`}
              style={{ opacity }}
            >
              <line x1="0" x2="0" y1="0" y2="8" style={{stroke: 'rgb(119, 119, 119)', strokeWidth: 2}}/>
              <text
                alignmentBaseline={textBaseline}
                textAnchor="start"
                x={0}
                y={0}
                transform={`translate(${textX},${textY})  rotate(30)`}
              >
                {value}

                <title>{value}</title>
              </text>
            </g>
          )
        }
      }}
      axisLeft={{
        orient: 'left',
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Rating',
        legendOffset: this.props.firstQuestion && this.props.firstQuestion.overrideDefaultScores? -100:-40,
        legendPosition: 'middle',
        tickValues:  this.props.firstQuestion && this.props.firstQuestion.overrideDefaultScores? [0, 1, 2, 3, 4, 5, 6]:[0, 1, 2, 3, 4, 5, 6, 7],
        format: (val) => {
          if(this.props.firstQuestion && this.props.firstQuestion.overrideDefaultScores && this.props.firstQuestion.scoreOverrides[val]) {
            return this.props.firstQuestion.scoreOverrides[val]
          }
          return val
        }
      }}
      pointSize={4}
      pointColor={{ theme: 'background' }}
      pointBorderWidth={1}
      pointBorderColor={{ from: 'serieColor' }}
      pointLabelYOffset={-12}
      useMesh={true}
      colors ={[
        'hsl(142, 100%, 25%)',
        'hsl(0, 100%, 34%)',
        '#0068bb',
        '#1c8ce5',
        '#06497d',
        '#215784'
      ]}
      legends={[
        {
          anchor: 'top',
          direction: 'column',
          justify: false,
          translateX: 0,
          translateY: -40,
          itemsSpacing: 0,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'circle',
          symbolBorderColor: 'rgba(0, 0, 0, .5)',
          effects: [
            {
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1
              }
            }
          ]
        }
      ]}
    />
    </div>
  }
}

export default OitStatistics;
